// extracted by mini-css-extract-plugin
module.exports = {"assignees":"AttachmentAssignees_assignees__rKo6V"};